let goodsData = [{
		"id": 1000271,
		"name": "无源电子挂锁",
		"name_title": "光缆交接箱锁、机柜锁",
		"model": "CG-GS-1",
		"sku_info": [{
			"sku_id": 1000271,
			"title": "",
			"sub_title": "",
			"ali_image": require('@/assets/img/products/guaLock/挂锁.gif'),
			"spec_json": {
				"image": "attr/v2/1000271/948F029DCF134EF23267994487994DA5/",
				"show_name": "正面"
			}
		}, {
			"sku_id": 1000271,
			"title": "",
			"sub_title": "",
			"ali_image": require('@/assets/img/products/guaLock/挂锁图纸.jpg'),
			"spec_json": {
				"image": "attr/v2/1000271/649AD35E36A9703BACBE1555AEB6D266/",
				"show_name": "图纸"
			}
		}]
	}, 
	
	{
		"id": 1000272,
		"name": "无源电子锁",
		"name_title": "电力柜锁",
		"model": 'CG-DL-1',
		"sku_info": [{
				"sku_id": 1000272,
				"ali_image": require('@/assets/img/products/psLock/rectangle/rectangle03.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "正面"
				}
			},
			{
				"sku_id": 1000272,
				"ali_image": require('@/assets/img/products/psLock/rectangle/rectangle02.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "开启"
				}
			},
			{
				"sku_id": 1000272,
				"ali_image": require('@/assets/img/products/psLock/rectangle/rectangle05.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "背面"
				}
			},
			{
				"sku_id": 1000274,
				"ali_image": require('@/assets/img/products/psLock/rectangle/rectangle04.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "侧面"
				}
			},
		]
	},
	{
		"id": 1000273,
		"name": "无源电子锁",
		"name_title": "光缆交接箱锁、机柜锁",
		"model": 'CG-3C-2',
		"sku_info": [{
				"sku_id": 1000273,
				"ali_image": require('@/assets/img/products/psLock/circle/circleLock1.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "开启"
				}
			},
			{
				"sku_id": 1000273,
				"ali_image": require('@/assets/img/products/psLock/circle/circleLock2.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "正面"
				}
			},
			{
				"sku_id": 1000273,
				"ali_image": require('@/assets/img/products/psLock/circle/circleLock3.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "侧面"
				}
			}
		]
	},
	{
		"id": 1000274,
		"name": "无源电子锁",
		"name_title": "箱体柜",
		"model": 'CG712-2',
		"sku_info": [{
				"sku_id": 1000274,
				"title": "",
				"sub_title": "",
				"ali_image": require('@/assets/img/products/psLock/712/712-2.jpg'),
				"spec_json": {
					"show_name": "正面"
				}
			},
			{
				"sku_id": 1000274,
				"title": "",
				"sub_title": "",
				"ali_image": require('@/assets/img/products/psLock/712/BL712.jpg'),
				"spec_json": {
					"show_name": "带盖"
				}
			}
		]
	},
	{
		"id": 1000275,
		"name": "无源电子锁",
		"name_title": "光缆交接箱锁、机柜锁",
		"model": 'CG-856-1',
		"sku_info": [{
				"ali_image": require('@/assets/img/products/psLock/865/865-1.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "正面"
				}
			},
			{
				"ali_image": require('@/assets/img/products/psLock/865/865-1.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "正面"
				}
			}
		]
	},
	
	{
		"id": 1000276,
		"name": "无源电子锁",
		"name_title": "光缆交接箱锁、机柜锁",
		"model": 'CG-712-1',
		"sku_info": [{
				"ali_image": require('@/assets/img/products/psLock/m712/712-2.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "正面"
				}
			},
			{
				"ali_image": require('@/assets/img/products/psLock/m712/712.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "侧面"
				}
			}
		]
	},
	{
		"id": 1000277,
		"name": "无源电子锁",
		"name_title": "光缆交接箱锁、机柜锁",
		"model": 'CG-CL-1',
		"sku_info": [
		    {
				"ali_image": require('@/assets/img/products/psLock/3c/3c1.png'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "正面"
				}
			},
			{
				"ali_image": require('@/assets/img/products/psLock/3c/3c.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "侧面"
				}
			},
		]
	},
	{
		"id": 1000278,
		"name": "无源电子锁",
		"name_title": "光缆交接箱锁、机柜锁",
		"model": 'CG-CCPT-1',
		"sku_info": [{
				"ali_image": require('@/assets/img/products/psLock/ccpt/ccpt1.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "正面"
				}
			},
			{
				"ali_image": require('@/assets/img/products/psLock/ccpt/ccpt2.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "侧面"
				}
			}
		]
	},
	{
		"id": 1000279,
		"name": "无源电子锁",
		"name_title": "光缆交接箱锁、机柜锁",
		"model": 'CG-840-2',
		"sku_info": [{
				"ali_image": require('@/assets/img/products/psLock/840/840-1.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "正面"
				}
			},
			{
				"ali_image": require('@/assets/img/products/psLock/840/840-11.jpg'),
				"spec_json": {
					"image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
					"show_name": "正面"
				}
			}
		]
	},
]

export default goodsData


// WEBPACK FOOTER //
// ./src/lib/passiveLockData.js